<template>
  <div class="contain">
    <!-- 整体架构布局 -->
    <el-container class="contain-box">
      <!-- 左侧导航 -->
      <el-aside width="260px">
        <div class="left_aside">
          <!-- logo -->
          <div class="logo">
            <img
              src="../assets/image/logo.png"
              alt=""
            />
          </div>
          <!-- 以下是菜单 -->
          <el-menu
            :default-active="activeIndex"
            background-color="#484c7f"
            text-color="#fff"
            class="el-menu-vertical-demo"
            @select="handlerSelect"
          >
            <el-menu-item
              index="/home"
              :route="{path:'/home'}"
            >
              <i class="el-icon-menu"></i>
              <span slot="title">项目管理</span>
            </el-menu-item>

            <!-- 信息库 -->
            <el-submenu index="information">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>信息库</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  index="/ExpertDatabase"
                  :route="{path:'/ExpertDatabase'}"
                >专家库
                </el-menu-item>
                <el-menu-item
                  index="/XfoundationDatabase"
                  :route="{path:'/XfoundationDatabase'}"
                >学协会库
                </el-menu-item>
                <el-menu-item
                  index="/JfoundationDatabase"
                  :route="{path:'/JfoundationDatabase'}"
                >基金会库
                </el-menu-item>
                <el-menu-item
                  index="/companyDatabase"
                  :route="{path:'/companyDatabase'}"
                >企业库</el-menu-item>
                <el-menu-item
                  index="/mediaDatabase"
                  :route="{path:'/mediaDatabase'}"
                >媒体库</el-menu-item>
                <el-menu-item
                  index="/periodicalList"
                  :route="{path:'/periodicalList'}"
                >期刊库</el-menu-item>
                <el-menu-item
                  index="/zxflist"
                  :route="{path:'/zxflist'}"
                >执行方库</el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- //1外籍将者库正在更新ui 好了就放出来 -->
            <el-menu-item
              index="/foreignerDatabase"
              :route="{path:'/foreignerDatabase'}"
            >
              <i class="el-icon-s-management"></i>
              <span slot="title">外籍讲者库</span>
            </el-menu-item>
            <!-- //1外籍将者库正在更新ui 好了就放出来 -->

            <el-menu-item
              index="/CaseLibrary"
              :route="{path:'/CaseLibrary'}"
            >
              <i class="el-icon-document"></i>
              <span slot="title">病例库</span>
            </el-menu-item>

            <el-menu-item
              index="/questionnaires"
              :route="{path:'/questionnaires'}"
            >
              <i class="el-icon-s-order"></i>
              <span slot="title">问卷管理</span>
            </el-menu-item>
            <!-- //! 图书馆 先隐藏 -->
            <!-- 图书馆 -->
            <el-submenu index="books">
              <template slot="title">
                <!-- <i class="el-icon-location"></i> -->
                <i class="el-icon-notebook-1"></i>
                <span>图书馆</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  index="/booksCollection"
                  :route="{path:'/booksCollection'}"
                >馆藏著作
                </el-menu-item>
                <!-- 如果是企业才会展示 -->
                <el-menu-item
                  v-if="userinfo.userTypeId==5"
                  index="/booksManagement"
                  :route="{path:'/booksManagement'}"
                >项目管理
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- //! 图书馆 先隐藏 -->
            <!-- //! 学院和企业服务还未对接接口 先隐藏 -->
            <!-- <el-menu-item index="4">
              <i class="el-icon-setting"></i>
              <span slot="title">学院</span>
            </el-menu-item>
            <el-menu-item
              index="/servise"
              :route="{path:'/servise'}"
            >
              <i class="el-icon-setting"></i>
              <span slot="title">企业服务</span>
            </el-menu-item> -->
            <!-- //! 学院和企业服务还未对接接口 先隐藏 -->
          </el-menu>
          <!-- 菜单结束 -->
        </div>
      </el-aside>
      <el-container>
        <!-- 头部开始 -->
        <el-header>
          <PersonalCenter />
        </el-header>
        <!-- 头部结束 -->
        <!-- 主体结构开始是 -->
        <el-main class="main-box">
          <keep-alive>
            <router-view v-if="$route.meta.keepalive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepalive" />
        </el-main>
        <!-- 主体结构结束 -->
      </el-container>
    </el-container>
  </div>
</template>
<script>
import PersonalCenter from './PersonalCenter'
export default {
  name: 'Home',
  components: {
    PersonalCenter
  },
  data () {
    return {
      activeIndex: "/home",
      userinfo: {}
    }
  },
  watch: {
    $route: {
      handler: function (to, from) {
        this.activeIndex = to.path
      },
      // 深度观察监听 
      deep: true,
      immediate: true
    }
  },
  created () {
    this.getMe()
  },
  methods: {
    handlerSelect (key, keyPath) {
      this.$router.push(key)
    },
    //获取个人信息
    async getMe () {
      const { data: data } = await this.$http.post('me')
      this.userinfo = data.data
    },
  }
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #ccc;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #fff;
}
.contain {
  height: 100%;
  width: 100%;
  padding: 24px 26px;

  .contain-box {
    height: 100%;
  }
  .left_aside {
    width: 100%;
    padding: 0 39px;
    height: 100%;
    background: #484c7f;
    border-radius: 21px;
    overflow: hidden;
    .logo {
      width: 176px;
      margin: 0 auto;
      margin-top: 41px;
      margin-bottom: 30px;
      img {
        width: 100%;
      }
    }
    .is-active {
      background: #fff !important;
      color: #141a68;
    }
    .el-menu {
      border-right: 0 none;
      li {
        border-radius: 6px;
        padding: 0;
      }
      .el-menu-item {
        min-width: 100px;
      }
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    span {
      font-size: 16px;
      color: #484c7f;
    }
    .header_pictor {
      width: 49px;
      height: 49px;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 8px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
